export default __webpack_public_path__ + "static/emphasise-metric-dont-34ee45b0bb20967f02073d869f39afc9.png";